import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiService } from '../../shared/services/apiService.service'
import { environment } from '../../../environments/environment';
import { log } from 'console';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-wishlist-list',
  templateUrl: './wishlist-list.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class WishlistListComponent implements OnInit {
  page: any;
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription
  productLoaded: boolean = false
  wishlist: any = [];
  totalItemsWishlist: any = 0;
  sub_lob: string;
  model: any;
  itemsPerPage: any = 10;
  currentPageWishlist: any = 1;
  itemsPerPagewish: any = 9
  imageUrl: any;
  constructor(private apiService: ApiService,    private behaviorService: BehaviourSubjectService,@Inject(PLATFORM_ID) private platformId: Object,

    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.behaviorService.isSmart.next(false);
    this.onWishlistTabClick({ "offset": 0, "limit": 9 });
  }

  pageChangeWishList(page: any) {
    this.currentPageWishlist = page;
    page = page - 1;
    let reqBody =
    {
      "offset": page * 9,
      "limit": 9
    };
    this.onWishlistTabClick(reqBody);
  }

  clickToRemove(event: any) {
    var temp = []
    temp.push(event);
    let data = {
      "action_type": "delete",
      "product_list": temp
    }
    this.sub.add(this.apiService.addToWishlist(data).subscribe({
      next: (res: any) => {
        this.toastrService.warning(res.data.msg)
        let req
        if (this.wishlist?.length == 1) {

          req = {
            "offset": (this.currentPageWishlist - 2) * 9,
            "limit": 9
          }
          this.currentPageWishlist = this.currentPageWishlist - 1
        }
        else {
          req = {
            "offset": (this.currentPageWishlist - 1) * 9,
            "limit": 9
          }
        }

        this.onWishlistTabClick(req)
        if (this.wishlist?.length >= 0)
          this.wishlist = []
      },
    }))
  }
  onWishlistTabClick(reqBody: any) {
    this.sub.add(this.apiService.getWishlistData(reqBody).subscribe({
      next: (res: any) => {
        this.productLoaded = true
        if (res.success) {
          this.wishlist = res?.data
          this.totalItemsWishlist = res?.total_count
          if (isPlatformBrowser(this.platformId)) {
          window.scroll(0, 0);
          }
          if (this.wishlist[0]?.sub_lob == "Icv Trucks")
            this.sub_lob = "trucks"
          if (this.wishlist[0]?.sub_lob == "Buses")
            this.sub_lob = "buses-vans"
          if (this.wishlist[0]?.sub_lob == "SCV Pickups")
            this.sub_lob = "scv-pickups"
          this.model = (this.wishlist[0]?.model.replace(/\s+/g, '-'))?.toLowerCase()
        } else {
          this.wishlist = []
          this.productLoaded = true
        }
      }
    }))
  }

  getUrl(item){
  if(item.images?.length > 1) {
    for(let i=0; i<item.images?.length; i++) {
      if(item.images[i].is_cover === true) {
        return item.images[i].image_url;
      } else {
        return item.images[0].image_url;
      }
    }
  } else {
    return item.images[0].image_url;
  }
  }

  redirect(data) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    var currentUrl = '/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id;
    return currentUrl;
    // this.router.navigate(['/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);

  }
  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }

}
